import React from "react";

import { Trash} from "react-bootstrap-icons";

function TagsList({
    items = [],
    onClickHandler,
    onDeleteHandler
}) {
    return (
        <ul className="list-group list-group-flush w-100">
            {items.map(item => (
                <li
                    key={item.uid}
                    className="list-group-item w-100 p-1"
                    style={{ 
                        // cursor: "pointer", 
                        display: 'flex', 
                        alignItems: 'stretch' 
                    }}
                >
                    <div style={{ 
                        flex: 1, 
                        padding: '4px' 
                    }}>
                        <div className="d-flex align-items-center">
                            <span className="flex-grow-1">{item.name}</span>

                            {onDeleteHandler && (<button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => onDeleteHandler(item.uid)}
                            >
                                <Trash size={16} />
                            </button>)}
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default TagsList;